import styled from 'styled-components';

import { LogoProps } from './Logo';

export const LogoContainer = styled.figure<LogoProps>`
  padding: 0;
  margin: 0;
  display: inline-block;

  > * {
    object-fit: fill;
    vertical-align: top;
    height: ${(props: LogoProps) => (props.height ? props.height + 'px' : 'auto')};
    width: ${(props: LogoProps) => (props.width ? props.width + 'px' : 'auto')};
  }
`;
